var render = function render(){var _vm=this,_c=_vm._self._c;return (Number.isFinite(_vm.tax))?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"tax-label"},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" "),(_vm.hasText)?[_vm._v("Including Taxes")]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }